import { ArrowRight, Loader2, Moon, Sun } from "lucide-react";
import { useLocation } from "react-router-dom";
import AuthModal from "@/components/AuthModal";
import ToolsMenu from "@/components/ToolsMenu";
import useSiteAuth from "@/components/useSiteAuth";
import "./HomepageFonts.css";
import "./Homepage.css";
import "./UseCases.css";

const NEXT_THEME = { system: "light", light: "dark", dark: "system" };

// The one header for every public page. Pass `auth` (from useSiteAuth) to share
// loading state with the page, and `theme` plus `onThemeChange` on pages that
// support dark mode.
export default function PublicHeader({ auth, theme, onThemeChange }) {
  const own = useSiteAuth();
  const { loading, demoLoading, handleConnect, handleDemo } = auth || own;
  const { pathname } = useLocation();
  const page = path => (pathname === path || pathname.startsWith(`${path}/`) ? "page" : undefined);
  const toolsCurrent = pathname.startsWith("/tools/") ? pathname : undefined;

  return <header className="ss-header"><div className="ss-container ss-header-inner">
    <a href="/" className="ss-brand" aria-label="SEO Signals home"><img src="/homepage/signal-mark.svg" width="36" height="36" alt="" /><span>SEO Signals</span></a>
    <nav aria-label="Main navigation">
      <a href="/#finds" data-testid="nav-finds">What you get</a>
      <a href="/#how" data-testid="nav-how">How it works</a>
      <a href="/#pricing">Pricing</a>
      <a href="/#faq" data-testid="nav-faq">Questions</a>
      <a href="/use-cases" data-testid="nav-use-cases" aria-current={page("/use-cases")}>Use cases</a>
      <ToolsMenu current={toolsCurrent} />
    </nav>
    <div className="ss-header-actions">
      {theme && onThemeChange && <button className="ss-theme" aria-label={theme === "system" ? "Theme: system. Switch to light" : theme === "light" ? "Theme: light. Switch to dark" : "Theme: dark. Switch to system"} onClick={() => onThemeChange(NEXT_THEME[theme])} title={`Theme: ${theme}`}>{theme === "dark" ? <Moon size={18} aria-hidden="true" /> : <Sun size={18} aria-hidden="true" />}</button>}
      <AuthModal onGoogle={handleConnect} onDemo={handleDemo} googleLoading={loading} demoLoading={demoLoading} trigger={<button className="ss-login" data-testid="nav-login-button">Log in</button>} />
      <button className="ss-button ss-primary" data-testid="nav-connect-button" onClick={handleConnect} disabled={loading}>{loading ? <Loader2 size={18} className="ss-spin" aria-hidden="true" /> : null}Show my priorities <ArrowRight size={18} aria-hidden="true" /></button>
    </div>
  </div></header>;
}
